import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SuggestionListsService} from '../../services/suggestion-lists.service';
import {ComponentBackgroundService} from '../../../../../services/component-background.service';
import {UserService} from '../../../../../services/user.service';
import {AdminService} from '../../../../../services/admin.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationPopupComponent} from '../../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../../../../models/user.model';
import { ToastService } from '../../../../../services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

import { SuggestionEconomics, ECONOMIC_SECTIONS, emptySuggestionEconomics,
  validEconomicDecimal, normalizeSuggestionEconomics, restoreSuggestionEconomics,
  suggestionPaysBackInHalfYear } from '../../models/suggestion-economics.model';

const MONEY = 'money';
const HOURS = 'hours';
const NEW_ECONOMICS_CURRENCY = 'USD';
const ECONOMIC_FIELDS = [MONEY, HOURS];
const ZERO_VALUE = 0;
const SUGGESTION_DRAFT_SAVE_FAILED = 'SUGGESTION_DRAFT_SAVE_FAILED';
const SUGGESTION_DRAFT_SAVED = 'SUGGESTION_DRAFT_SAVED';


const EDIT = 'edit';
const CORRECTION = 'correction';
const STANDARD = 'Standard ';


const SUGGESTION_LIST_ROUTE = '/dashboard/my-suggestion-lists';
const CONFIRMED_RESULT = 'ok';
const UNSAVED_CONFIRMATION = 'Unsaved data will be lost. Continue?';
const EMPTY_TEXT = '';
const TEXT_TYPE = 'string';

const BEFORE_UNLOAD_EVENT = 'beforeunload';
const LEGACY_ROUTING_DEPARTMENT_ID = '62a311f4bff1153571181b36';
const SUGGESTION_ROUTING_ERRORS: { [code: string]: string } = {
  SUGGESTION_RECIPIENT_NOT_CONFIGURED: 'SUGGESTION_CREATE_RECIPIENT_MISSING',
  SUGGESTION_SELF_REVIEW_UNRESOLVED: 'SUGGESTION_CREATE_SELF_REVIEW_BLOCKED',
  SUGGESTION_ACTOR_NOT_AVAILABLE: 'SUGGESTION_CREATE_ACTOR_UNAVAILABLE',
};
const SUGGESTION_SEND_ERROR = 'Error saving and sending this Suggestion List';
const SUGGESTION_MISSING_HEAD = 'You can not create suggestion lists because there is no Head in the department';
const SUGGESTION_INVALID_INPUT = 'If you want to send this Suggestion List for review, enter a Description '
  + '(must be at least 3 characters) or save it as Draft to continue later.';

interface SuggestionSubmissionInput {
  name: string | null;
  description: string;
  groupId?: string;
  economics?: SuggestionEconomics;
}

interface SuggestionSubmissionResponse {
  status: number;
}

enum ValidationConstants {
  MIN_DESCRIPTION_LENGTH = 3,
  MAX_TEMPLATE_LENGTH = 80
}

enum HttpStatus {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  NOT_FOUND = 404
}

@Component({
  selector: 'app-create-new-slist',
  templateUrl: './create-new-slist.component.html',
  styleUrls: ['./create-new-slist.component.css']
})
export class CreateNewSlistComponent implements OnInit, OnDestroy {
  readonly MIN_DESCRIPTION_LENGTH = ValidationConstants.MIN_DESCRIPTION_LENGTH;
  private readonly destroy$ = new Subject<void>();
  private isDestroyed = false;
  @ViewChild('suggestionEditor') private editorElement: ElementRef;

  readonly economicFields = ECONOMIC_FIELDS;
  economicSections: {key: string; label: string}[] = [];
  economicErrors: {[field: string]: boolean} = {};
  economicPayback: boolean | null = null;
  private savedEconomics = EMPTY_TEXT;
  private published = false;

  editMode = false;               // Check if edit mode activated
  draftForEdit = null;            // Draft for edit from SuggestionListsService
  standardTemplate = null;        // For get ID and Name of initiator standard

  draftId: string;                // Use if draft was opened
  initiatorUser = null;           // Use for ID and showing name of user
  initiatorDivision = null;       // groupId

  isLoaded = false;               // Show spinner while info is loading
  responseMessage: string;        // Set error message text here
  showErrorMsg = false;           // Show or hide error message
  showSuccessMsg = false;         // Show or hide error message

  allBtnsIsDisabled = false;      // Disable all buttons
  navigationConfirmed = false;
  skipAutomaticDraftSave = false;
  savedSLorDraft = {              // Temp object for canLeavePage()
    template: '',
    description: ''
  };

  isAdmin = false;
  isUser = false;
  isHead = false;

  internalServerError = false;
  getGroupError = false;
  getSelfError = false;
  id;
  thisDraft;
  groups = [];
  selectDepartment;
  currentUser; 
  user: User;
  previewText: string = '';
  isTooLong: boolean = false;
  photoError: string = '';

  // Properties to track hover state and validation highlighting
  isSaveButtonHovered = false;
  highlightDescription = false;
  highlightPreview = false;

  constructor(public suggestionListsService: SuggestionListsService,
              public componentBackgroundService: ComponentBackgroundService,
              private userService: UserService,
              private adminService: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              private toastService: ToastService) {              
    this.id = this.route.snapshot.params['id'];
  }

  checkLength() {
    this.isTooLong = this.suggestionListsService.templateService.trim().length > ValidationConstants.MAX_TEMPLATE_LENGTH;
  }

  functionToRun(e) {
    const confirmationMessage = '\o/';
    (e || window.event).returnValue = confirmationMessage;
    return confirmationMessage;
  }


  ngOnDestroy() {
    this.isDestroyed = true;
    this.destroy$.next();
    this.destroy$.complete();
    const editorNode: Node = this.editorElement && this.editorElement.nativeElement;
    const browserWindow = editorNode && editorNode.ownerDocument && editorNode.ownerDocument.defaultView;
    if (browserWindow) { browserWindow.removeEventListener(BEFORE_UNLOAD_EVENT, this.functionToRun); }

    if (!this.skipAutomaticDraftSave && !this.canLeavePage()) {
      this.onSaveDraftAction();

    }
  }

  getAllGroupForList() {
		this.adminService.getAllGroups().subscribe(
			(response: any) => {
				this.groups = response.body;
			},
		);
	}


  canLeavePage() {
    return this.published || (this.savedEconomics === JSON.stringify(this.suggestionListsService.economicsService) && this.savedSLorDraft.template.trim() === this.suggestionListsService.templateService.trim() &&
      this.savedSLorDraft.description.trim() === this.suggestionListsService.descriptionService.trim());
  }

  disableSaveBtn() {
    return (this.suggestionListsService.descriptionService.trim().length < ValidationConstants.MIN_DESCRIPTION_LENGTH || 
            this.suggestionListsService.templateService.trim().length < ValidationConstants.MIN_DESCRIPTION_LENGTH ||
            this.suggestionListsService.templateService.trim().length > ValidationConstants.MAX_TEMPLATE_LENGTH);
  }

  ngOnInit() {
    this.initializeEconomics();
    this.checkRole();
    this.currentUser = this.userService.getLocal();
    this.getAllGroupForList();
    this.savedSLorDraft = {template: this.suggestionListsService.templateService,
      description: this.suggestionListsService.descriptionService};
    if (this.suggestionListsService.getListType() === EDIT) { this.loadDraftForm(); return; }
    this.suggestionListsService.descriptionService = EMPTY_TEXT;
    this.suggestionListsService.photosService = [];
    this.suggestionListsService.photoUrlsService = [];
    this.userService.getUserFromAPI(this.currentUser.id).takeUntil(this.destroy$).subscribe(
      response => this.loadInitiatorGroup(response), () => this.initializationFailed(true));
  }

  ngAfterViewInit() {
    const node: Node = this.editorElement && this.editorElement.nativeElement;
    const browserWindow = node && node.ownerDocument && node.ownerDocument.defaultView;
    if (browserWindow) { browserWindow.addEventListener(BEFORE_UNLOAD_EVENT, this.functionToRun); }
  }

  private initializeEconomics() {
    this.suggestionListsService.economicsService = emptySuggestionEconomics(!!this.id);
    this.suggestionListsService.economicsService.currency = NEW_ECONOMICS_CURRENCY;
    this.economicSections = ECONOMIC_SECTIONS.filter(section => this.id ? section.key === CORRECTION : section.key !== CORRECTION);
    this.savedEconomics = JSON.stringify(this.suggestionListsService.economicsService);
  }

  private loadDraftForm() {
    this.editMode = true;
    if (!this.suggestionListsService.hasDraft()) { this.initializationFailed(false); return; }
    this.draftForEdit = this.suggestionListsService.getDraft();
    this.draftId = this.draftForEdit.id;
    this.initiatorUser = this.draftForEdit.initiator;
    this.initiatorDivision = this.draftForEdit.group;
    this.suggestionListsService.templateService = this.draftForEdit.template || EMPTY_TEXT;
    this.suggestionListsService.descriptionService = this.draftForEdit.description || EMPTY_TEXT;
    if (!this.id && this.draftForEdit.economics) {
      this.suggestionListsService.economicsService = restoreSuggestionEconomics(this.draftForEdit.economics);
    }
    this.refreshEconomicPayback();
    this.savedEconomics = JSON.stringify(this.suggestionListsService.economicsService);
    this.savedSLorDraft = {template: this.suggestionListsService.templateService,
      description: this.suggestionListsService.descriptionService};
    this.isLoaded = true;
  }

  refreshEconomicPayback() {
    this.economicPayback = this.id ? null : suggestionPaysBackInHalfYear(this.suggestionListsService.economicsService);
  }

  private loadInitiatorGroup(response) {
    if (response.status !== HttpStatus.OK) { this.initializationFailed(true); return; }
    this.initiatorUser = response.body;
    this.adminService.getGroupByID(this.initiatorUser.mainGroup).takeUntil(this.destroy$).subscribe(result => {
      if (result.status !== HttpStatus.OK) { this.initializationFailed(false); return; }
      this.initiatorDivision = result.body;
      this.selectDepartment = this.initiatorDivision.id;
      this.standardTemplate = this.suggestionListsService.getStandard() || null;
      this.suggestionListsService.templateService = this.standardTemplate ? STANDARD + this.standardTemplate.number : EMPTY_TEXT;
      this.savedSLorDraft = {template: this.suggestionListsService.templateService, description: EMPTY_TEXT};
      this.isLoaded = true;
    }, () => this.initializationFailed(false));
  }

  private initializationFailed(self: boolean) {
    this.internalServerError = true;
    this.getSelfError = self;
    this.getGroupError = !self;
    this.isLoaded = true;
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }
  }


  // Check if Draft is valid
  isDraftValid() {
    return this.initiatorUser !== null &&
      this.initiatorDivision !== null &&
      this.suggestionListsService.descriptionService.length >= this.MIN_DESCRIPTION_LENGTH;
  }

  // Cancel button pressed
  onCancelAction() {
    // TODO проверять событие закрытия вкладки или перехода на другой URL!
    // https://stackblitz.com/edit/angular-rgsa51
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = UNSAVED_CONFIRMATION;
    modalRef.result.then((result) => {
      if (result === CONFIRMED_RESULT) {
        this.navigationConfirmed = true;
        this.responseMessage = EMPTY_TEXT;
        this.showErrorMsg = false;
        this.showSuccessMsg = false;
        // Go to my suggestion lists
        this.router.navigate([SUGGESTION_LIST_ROUTE]);
      }
    });
  }

  onDepartmentChange(id): void {
    this.selectDepartment = id;
  }

  onPhotoSelect(event: any) {
    const files = event.target.files;
    this.photoError = '';
    
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.photoError = 'ERROR_PHOTO_TYPE';
        continue;
      }
      
      if (!this.suggestionListsService.addPhoto(file)) {
        this.photoError = 'ERROR_PHOTO_LIMIT';
        break;
      }
    }
    
    event.target.value = '';
  }

  removePhoto(index: number) {
    this.suggestionListsService.removePhoto(index);
    this.photoError = '';
  }
  // Save Draft button pressed
  // Do not check if Draft is valid here
  trackEconomicSection(index: number, section: {key: string}): string { return section.key; }
  trackEconomicField(index: number, field: string): string { return field; }

  validateEconomics(): boolean {
    this.economicErrors = {};
    this.economicSections.forEach(section => {
      [MONEY, HOURS].forEach(field => {
        if (!validEconomicDecimal(this.suggestionListsService.economicsService[section.key][field])) {
          this.economicErrors[section.key + field] = true;
        }
      });
    });
    return Object.keys(this.economicErrors).length === ZERO_VALUE;
  }

  onSaveDraftAction() {
    if (this.published || this.allBtnsIsDisabled || !this.initiatorDivision || (!this.id && !this.validateEconomics())) { return; }
    const snapshot = {template: this.suggestionListsService.templateService,
      description: this.suggestionListsService.descriptionService};
    const economicsSnapshot = JSON.stringify(this.suggestionListsService.economicsService);
    const draft: {id?: string; groupId: string; template: string; description: string; economics?: SuggestionEconomics} = {
      groupId: this.initiatorDivision.id, template: snapshot.template || null, description: snapshot.description
    };
    if (!this.id) { draft.economics = normalizeSuggestionEconomics(this.suggestionListsService.economicsService); }
    const existing = this.suggestionListsService.hasDraft();
    if (existing) { draft.id = this.draftId; }
    this.allBtnsIsDisabled = true;
    const request = existing ? this.suggestionListsService.updateDraft(draft) : this.suggestionListsService.addNewDraft(draft);
    request.subscribe(response => this.draftSaved(response, {text: snapshot, economics: economicsSnapshot}),
      () => { if (!this.isDestroyed) { this.showSendError(SUGGESTION_DRAFT_SAVE_FAILED); } });
  }

  private draftSaved(response, snapshot: {text: {template: string; description: string}; economics: string}) {
    if (this.isDestroyed) { return; }
    this.allBtnsIsDisabled = false;
    if (response.status !== HttpStatus.OK && response.status !== HttpStatus.CREATED) {
      this.showSendError(SUGGESTION_DRAFT_SAVE_FAILED); return;
    }
    this.savedSLorDraft = snapshot.text;
    this.savedEconomics = snapshot.economics;
    if (response.body && response.body.id) {
      this.draftId = response.body.id;
      this.suggestionListsService.setDraft(response.body);
    }
    this.responseMessage = SUGGESTION_DRAFT_SAVED;
    this.showSuccessMsg = true;
    this.showErrorMsg = false;
  }

  // Save and Send for review button pressed
  onSendForReviewlAction(): void {
    if (this.isDestroyed || this.allBtnsIsDisabled) { return; }
    this.responseMessage = EMPTY_TEXT;
    this.showErrorMsg = false;
    this.showSuccessMsg = false;
    if (!this.validateEconomics()) { return; }
    if (!this.isLoaded || this.internalServerError || !this.isDraftValid() || this.disableSaveBtn()) {
      this.showSendError(SUGGESTION_INVALID_INPUT);
      return;
    }
    this.allBtnsIsDisabled = true;
    const draft = this.buildSuggestionSubmission();
    const data = this.suggestionListsService.createFormDataWithPhotos(draft);
    const request = this.id ? this.suggestionListsService.addNewMist(this.id, data)
      : this.suggestionListsService.addNewSL(data);
    request.takeUntil(this.destroy$).subscribe(
      response => this.handleSuggestionSubmitted(response, draft),
      error => this.handleSuggestionSendError(error),
    );
  }

  private buildSuggestionSubmission(): SuggestionSubmissionInput {
    const draft: SuggestionSubmissionInput = {
      name: this.suggestionListsService.templateService.trim() ? this.suggestionListsService.templateService : null,
      description: this.suggestionListsService.descriptionService,
      economics: normalizeSuggestionEconomics(this.suggestionListsService.economicsService),
    };
    if (!this.id && this.isHead && this.isAdmin && this.currentUser
      && this.currentUser.mainGroup === LEGACY_ROUTING_DEPARTMENT_ID) {
      draft.groupId = this.selectDepartment;
    }
    return draft;
  }

  private handleSuggestionSubmitted(response: SuggestionSubmissionResponse, draft: SuggestionSubmissionInput): void {
    if (response.status !== HttpStatus.CREATED && response.status !== HttpStatus.OK) {
      this.showSendError(SUGGESTION_SEND_ERROR);
      return;
    }
    this.published = true;
    this.suggestionListsService.clearSLData();
    this.suggestionListsService.setDraft(null);
    this.savedSLorDraft = { template: EMPTY_TEXT, description: EMPTY_TEXT };
    this.savedEconomics = JSON.stringify(this.suggestionListsService.economicsService);
    this.navigationConfirmed = true;
    this.allBtnsIsDisabled = false;
    this.suggestionListsService.showSuccessMsgOnSLList = true;
    this.router.navigate([SUGGESTION_LIST_ROUTE]);
  }

  private handleSuggestionSendError(error: HttpErrorResponse): void {
    const code = error.status === HttpStatus.BAD_REQUEST && typeof error.error === TEXT_TYPE ? error.error.trim() : EMPTY_TEXT;
    const knownMessage = Object.prototype.hasOwnProperty.call(SUGGESTION_ROUTING_ERRORS, code) ? SUGGESTION_ROUTING_ERRORS[code] : EMPTY_TEXT;
    const message = knownMessage
      || (error.status === HttpStatus.NOT_FOUND ? SUGGESTION_MISSING_HEAD : SUGGESTION_SEND_ERROR);
    this.showSendError(message);
  }

  private showSendError(message: string): void {
    this.responseMessage = message;
    this.showErrorMsg = true;
    this.showSuccessMsg = false;
    this.allBtnsIsDisabled = false;
  }

  
  // Methods to handle save button hover
  onSaveButtonMouseEnter() {
    this.isSaveButtonHovered = true;
    this.updateFieldHighlights();
  }

  onSaveButtonMouseLeave() {
    this.isSaveButtonHovered = false;
    this.highlightDescription = false;
    this.highlightPreview = false;
  }

  // Method to update field highlights based on validation
  updateFieldHighlights() {
    this.highlightDescription = (
      !this.suggestionListsService.descriptionService || 
      this.suggestionListsService.descriptionService.trim().length < this.MIN_DESCRIPTION_LENGTH
    );
    
    this.highlightPreview = (
      !this.suggestionListsService.templateService || 
      this.suggestionListsService.templateService.trim().length < this.MIN_DESCRIPTION_LENGTH
    );
  }

}




// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/create-new-slist/create-new-slist.component.ts